import { Box, Typography } from "@mui/material";
import { useTheme } from "../../../../context/themeContext";
import styles from "./style.module.css";

const PrimaryHeader = () => {
  const { theme, darkMode } = useTheme();
  return (
    <Box
      className={styles.primary}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        alignSelf: "stretch",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontSize: "72px",
          fontWeight: "700",
          color: darkMode ? "#FFF" : theme.palette.primary.main,
        }}
      >
        Discover
      </Typography>
    </Box>
  );
};

export default PrimaryHeader;
